import { FluidOwaScenario } from 'owa-fluid-validations';

export const OWA_APP_ID = '00000002-0000-0ff1-ce00-000000000000';
export const DriveId: string = 'driveId';
export const ItemId: string = 'itemId';

export const COMPOSE_ONLY_FLUID_KEEP_BODY = 'owaFluidKeepBodyOnSend';

export const FluidOwaScenarioNames = {
    [FluidOwaScenario.CALENDAR_CREATE_NEW]: 'CalendarCreateNew',
    [FluidOwaScenario.MAIL_CREATE_NEW]: 'MailCreateNew',
    [FluidOwaScenario.UNKNOWN_CREATE_NEW]: 'UnknownCreateNew',

    [FluidOwaScenario.CALENDAR_FLUIDIFY]: 'CalendarFluidify',
    [FluidOwaScenario.MAIL_FLUIDIFY]: 'MailFluidify',
    [FluidOwaScenario.UNKNOWN_FLUIDIFY]: 'UnknownFluidify',

    [FluidOwaScenario.CALENDAR_COMPONENT_PASTE]: 'CalendarComponentPaste',
    [FluidOwaScenario.MAIL_COMPONENT_PASTE]: 'MailComponentPaste',
    [FluidOwaScenario.UNKNOWN_COMPONENT_PASTE]: 'UnknownSourcePaste',

    [FluidOwaScenario.MAIL_READINGPANE_SCENARIO]: 'MailReadingPane',
    [FluidOwaScenario.CALENDAR_READ_SCENARIO]: 'CalendarRead',
    [FluidOwaScenario.UNKNOWN_READ_SCENARIO]: 'UnknownReadOnly',

    [FluidOwaScenario.SPACES_SCENARIO]: 'Spaces',
};

export const OUTLOOK_APP_NAME = 'Outlook_Web_App';
export const CH2_APP_NAME = 'OneNoteMeetings';
export const FLUID_ENTITY_TYPE = 'OWAFluid';
export const FLUID_CHANGE_SOURCE = 'fluid';
